import axios from 'axios';
import LogUtils from "./LogUtils";
import StorageUtils from './StorageUtils';
import * as Url from "./Url";
import router from '../router/index'
import $use from './use.js'
import store from '@/store';


import {
	encryptBase64,
	encryptWithAes,
	generateAesKey,
	decryptWithAes,
	decryptBase64
} from './crypto';
import {
	encrypt,
	decrypt
} from './jsencrypt';


axios.defaults.timeout = 40000; // 请求超时时间
axios.defaults.baseURL = Url.HOST

//使用create方法创建axios实例
let instance = axios.create({
	// baseURL: Url.HOST,
	headers: {
		'content-type': 'multipart/form-data'
	},
});

let jsonReq = axios.create();
//http net 添加请求拦截器
axios.interceptors.request.use(config => {
		let token = ''
		if (config.params && config.params.token) {
			token = config.params.token
		}
		let ask = generateAesKey()
		config.data = JSON.stringify(config.data);
		config.headers = {
			'Content-Type': 'application/json',
			// 'Content-Type': 'application/x-www-form-urlencoded',
			'Authorization': StorageUtils.getStringData("token") ?
				`Bearer ${StorageUtils.getStringData("token")}` : token ? `Bearer ${token}` : '',
			'content-language': 'zh_CN', //en_Us
			'clientId': Url.clientId,
			'isencrypt': true,
			'encrypt-key': encrypt(encryptBase64(ask)),
		}
		if (config.method != 'get') {
			config.data = encryptWithAes(config.data, ask)
		}
		return config;
	},
	error => {
		LogUtils.log('请求拦截器 error = ' + error)
		return Promise.reject(error);
	}
);


//添加响应拦截器    异常处理
axios.interceptors.response.use(
	response => {
		if (response.status === 200 && response.data.code == 200) {
			return Promise.resolve(response)
		} else if (response.status === 200 && response.data.code != 200) {
			switch (response.data.code) {
				case 400:
					LogUtils.log('错误请求')
					$use.msg('Bad Request', 'error')
					break;
				case 401:
					router.push('/login')
					LogUtils.log('未授权，请重新登录')
					$use.msg('Please log in and try again', 'error')
					StorageUtils.setAccount()
					localStorage.clear()
					store.dispatch('SetInfo', {})
					break;
				case 403:
					LogUtils.log('拒绝访问')
					$use.msg('access denied', 'error')
					break;
				case 404:
					LogUtils.log('请求错误,未找到该资源')
					$use.msg('Request error, resource not found', 'error')
					break;
				case 405:
					LogUtils.log('请求方法未允许')
					$use.msg('Request method not allowed', 'error')
					break;
				case 408:
					LogUtils.log('请求超时')
					$use.msg('request timeout', 'error')
					break;
				case 500:
					LogUtils.log('服务器端出错')
					$use.msg(response.data.msg || 'Error on the server', 'error')
					break;
				case 501:
					LogUtils.log('网络未实现')
					$use.msg('Network not implemented', 'error')
					break;
				case 502:
					LogUtils.log('网络错误')
					$use.msg('network error', 'error')
					break;
				case 503:
					LogUtils.log('服务不可用')
					$use.msg('service is not available', 'error')
					break;
				case 504:
					LogUtils.log('网络超时')
					$use.msg('network timeout', 'error')
					break;
				case 505:
					LogUtils.log('http版本不支持该请求')
					$use.msg('Http Version does not support this request', 'error')
					break;
				default:
					LogUtils.log(`连接错误${err.response.status}`)
					$use.msg('connection error', 'error')
			}
		} else {
			LogUtils.log('连接到服务器失败')
		}
		return Promise.reject(response)
	}, err => {
		return Promise.reject(err)
	})


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function getRequest(url, data = {}) {
	return new Promise((resolve, reject) => {
		axios.get(url, {
			params: data,
		}).then(response => {
			if (response.data) {
				if (response.data.code == 200) {
					resolve(response.data);
				} else {
					$use.msg(response.data.msg, 'error')
				}
			} else {
				$use.msg('request timeout', 'error')
			}

		}).catch(err => {
			reject(err)
		})
	})
}


// post 请求
export function postRequest(url, data = {}) {
	return new Promise((resolve, reject) => {
		axios.post(url, data).then(response => {
			if (response.data) {
				if (response.data.code == 200) {
					resolve(response.data);
				} else {
					$use.msg(response.data.msg, 'error')
					reject(response.data)
				}
			} else {
				$use.msg('request timeout', 'error')
			}
		}).catch(err => {
			reject(err);
		});
	});
}

/**
 * JSON请求
 */
export function postJsonRequest(url, data = {}) {
	return new Promise((resolve, reject) => {
		jsonReq.post(url, data).then(response => {
			resolve(response.data);
		}, err => {
			reject(err)
		})
	})
}

/**
 * 表单请求
 * @param url
 * @param data
 * @returns {Promise<any>}
 */
export function postFormRequest(url, data = {}, proxy) {
	return new Promise((resolve, reject) => {
		instance.post(url, data, {
			headers: {
				'token': StorageUtils.getStringData("loginToken"),
				// 'token':  'Bearer ' +StorageUtils.getStringData("loginToken"),
			}
		}).then(response => {
			resolve(response.data);
			LogUtils.log("==================== POST Form Request success Start =======================")
			LogUtils.log("url = " + url);
			LogUtils.log("requestParams = ");
			for (let [key, value] of data) {
				LogUtils.log("      " + key + ":" + value);
			}
			LogUtils.log("responeData = " + JSON.stringify(response.data))
			LogUtils.log("==================== POST Form Request success End =========================")
		}, err => {
			reject(err)
			LogUtils.log("==================== POST Form Request error Start =======================")
			LogUtils.log("url = " + url);
			LogUtils.log("requestParams = ");
			for (let [key, value] of data) {
				LogUtils.log("      " + key + ":" + value);
			}
			LogUtils.log("respone error = " + JSON.stringify(err))
			LogUtils.log("==================== POST Form Request error End =========================")
		})
	})
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patchRequest(url, data = {}) {
	return new Promise((resolve, reject) => {
		axios.patch(url, data)
			.then(response => {
				resolve(response.data);
			}, err => {
				reject(err)
			})
	})
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function putRequest(url, data = {}) {
	return new Promise((resolve, reject) => {
		axios.put(url, data)
			.then(response => {
				resolve(response.data);
			}, err => {
				reject(err)
			})
	})
}

// 封装jsonp请求
export function jsonp(url, successCallback = function () {}, errorCallback = function () {}) {
	const callbackName = `jsonpCallback_${new Date().getTime()}`;
  const script = document.createElement('script');
  script.src = `${url}&callback=${callbackName}`;

	window[callbackName] = function (data) {
		if (typeof successCallback === 'function') {
			successCallback(data);
        }
        document.body.removeChild(script);
	};

  script.onerror = function () {
    document.body.removeChild(script);
  };

  document.body.appendChild(script);
}